import { gql } from '@apollo/client';

export const CREATE_USER_GROUP = gql`
	mutation createGroup($name: String!, $description: String) {
		createCrewMemberGroup(name: $name, description: $description) {
			... on CrewMemberGroupSuccessResponse {
				group {
					id
					name
					description
					createdBy
					membersCount
				}
			}
			... on CrewMemberGroupErrorResponse {
				errors
			}
		}
	}
`;
